/** インポートリクエスト項目のステータスラベル */
export const STATUS_LABELS: Record<string, string> = {
  pending: '未処理',
  done: '完了',
  failed: '失敗',
};

/** インポートリクエスト項目のステータスに対応する Tag カラー */
export const STATUS_TAG_COLORS: Record<string, 'orange' | 'green' | 'red' | 'gray'> = {
  pending: 'orange',
  done: 'green',
  failed: 'red',
};

/** インポートリクエスト一覧用のステータスバッジスタイル */
export const IMPORT_REQUEST_STATUS_STYLES: Record<string, { label: string; className: string }> = {
  pending: {
    label: '未完了',
    className: 'bg-[#fff4cc] text-[#7a5c00]',
  },
  done: {
    label: '完了',
    className: 'bg-[#e6f6ee] text-[#1f7a52]',
  },
};
